import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Alert } from '@mui/material';
import { useAuth } from '../hooks/useAuth';

function ResendConfirmation() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const { resendConfirmationEmail } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await resendConfirmationEmail(email);
      setMessage('Email di conferma reinviata. Controlla la tua casella di posta.');
      setIsError(false);
    } catch (error) {
      setMessage('Errore nel reinvio dell\'email. Riprova più tardi.');
      setIsError(true);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, margin: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom id="resend-confirmation-title" component="h1">
        Richiedi nuova email di conferma
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        aria-labelledby="resend-confirmation-title"
      >
        <TextField
          fullWidth
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          required
          inputProps={{
            'aria-label': 'Email address for confirmation',
            'aria-required': 'true'
          }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          aria-label="Resend confirmation email"
        >
          Invia
        </Button>
      </Box>
      {message && (
        <Alert severity={isError ? 'error' : 'success'} sx={{ mt: 2 }} role={isError ? 'alert' : 'status'}>
          {message}
        </Alert>
      )}
    </Box>
  );
}

export default ResendConfirmation;